import { gql } from '@apollo/client'

export const RemoveTracks = gql`
    mutation RemoveTracks($roomId: ID!, $trackIds: [ID!]!) {
      removeTracks(roomId: $roomId, trackIds: $trackIds)
    }
`

export default RemoveTracks
